import React from "react";
import "./widgets.scss";
import "./simplenumerical.scss";
import wrapWidget from "./WidgetHOC";
import wrapMockedWidget from "./MockedWidgetHOC";

//const TEMP_DEVICE_UID = 3978;
//const TEMP_SENSOR_UID = 62;

const SimpleNumerical = props => {
  let { liveSensorValue, resolvedSensorConfig, widgetGridHeight=2 } = props;

  let sensorValue = "-";
  let sensorUnit = "";

  try {
    sensorValue = liveSensorValue.value;
    //sensorValue = parseFloat(sensorValue).toFixed(2);
    sensorUnit = resolvedSensorConfig.hasOwnProperty("unit") 
      ? unescape(resolvedSensorConfig.unit.value)
      : sensorUnit;
  } catch (error) {
    //console.error(error)
  }

  // Scale value font size proportional to widgetGridHeight
  // Padding-top is to move the text a bit downwards, when in the samllest size

  let fontSizeOverride = {fontSize: 24*widgetGridHeight**1.2} //TODO: 1.2->1.5
  let paddingOverride = {paddingTop: widgetGridHeight>1?0:5}
  return (
    <div className="simplenumerical-widget">
      <p className="simplenumerical-widget-value" style={{...fontSizeOverride, ...paddingOverride}}>{sensorValue}</p>
      <p className="simplenumerical-widget-unit" style={paddingOverride}>{sensorUnit}</p>
    </div>
  );
};

const MockedSimpleNumerical = wrapMockedWidget(SimpleNumerical);
export {MockedSimpleNumerical};
export default wrapWidget(SimpleNumerical);
